import React from 'react';
import { ctaMicrocopy, hero } from '../data/content';
import { CtaButton } from './CtaButton';
import { ImageSlot } from './ImageSlot';
type HeroProps = {
  heroMockupUrl: string;
};
export function Hero({
  heroMockupUrl
}: HeroProps) {
  return <section id="hero" aria-labelledby="hero-title" className="bg-cream" data-id="element-87" data-mp="9l33na9io82x">
      <div className="mx-auto grid max-w-page gap-6 px-5 pb-10 pt-7 md:px-8 md:pb-16 md:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-x-12 lg:gap-y-8" data-id="element-88" data-mp="4n1kkpc3c8rg">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-89" data-mp="xae8p3xwgomv">
          <p className="mb-3 font-display text-[11px] font-bold tracking-[0.1em] text-orange-ink sm:text-[12px] sm:tracking-[0.14em]" data-id="element-90" data-mp="xb5s7ge82vws">{hero.eyebrow}</p>
          <h1 id="hero-title" className="font-display text-[2.05rem] font-extrabold uppercase leading-[1.06] tracking-tight text-teal sm:text-[2.6rem] lg:text-[3.3rem]" data-id="element-91" data-mp="ncq1vfn0rqoc">
            {hero.title}
          </h1>
          <p className="mt-4 text-[17px] leading-relaxed text-ink/80 md:text-[19px]" data-id="element-92" data-mp="3814alm6t1smr">{hero.sub}</p>
        </div>

        <div className="mx-auto aspect-[4/3] w-full max-w-[360px] sm:max-w-[460px] lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:max-w-none lg:self-center" data-id="element-93" data-mp="3j6fvvj9ob1ao">
          <ImageSlot url={heroMockupUrl} alt="Preach Ready™ pack with the main book and 5 bonus booklets" slotName="heroMockupUrl" fit="contain" eager data-id="element-94" data-mp="399bbnoze1fwi" />
        </div>

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-95" data-mp="30iayctjm0ckb">
          <CtaButton microcopy={ctaMicrocopy} data-id="element-96" data-mp="30fy8zvbiuzx8" />
        </div>
      </div>
    </section>;
}